import actions from './actions';

const initState = {
    data: []
};

export default function WaterReducer(state = initState, action) {
    switch (action.type) {
        case actions.Water_SUCCESS:
            return {
                ...state,
                data: action.payload.data
            };
        default:
            return state;
    }
}
